import React, { useState } from 'react';
import { ContentSwitcher, Grid } from '../ecosystem'
import { PageHeading } from '../ecosystem/mybswh'
import { DatePicker } from '../ecosystem/core'

const SchedulingComponents = () => {
    const [contentSwitchSize, setContentSwitchSize] = useState('sm')
    const [contentSwitchOptions, setContentSwitchOptions] = useState(["Options 1", "Options 2"])

    const contentSwitchOptionsB= ["Options 1", "Options 2", "Option 3", "Options 4"]
    const contentSwitchOptionsA = ["Options 1", "Options 2"]
    const callBack = (value) => {
         console.log('value', value)
    }


    const [selectedDay, setSelectedDay] = useState();


    return (
        <Grid className="body-content">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading heading="Scheduling Components" />
                    <div style={{'marginTop': '20px'} }>
                        <h3>Content Switcher</h3>
                        <div style={{ 'marginBottom': '20px' }}>Size: 
                            <select style={{ 'width': '100px' }}
                                value={contentSwitchSize}
                                onChange={(event) => setContentSwitchSize(event.target.value)}>
                                <option value="sm">Small</option>
                                <option value="lg">Large</option>
                            </select>
                        </div>
                        <div style={{ 'marginBottom': '20px' }}>Options: 
                            <select style={{ 'width': '100px' }}
                                value={contentSwitchOptions.length}
                                onChange={(event) => setContentSwitchOptions(event.target.value == 4 ? contentSwitchOptionsB : contentSwitchOptionsA)}>
                                <option value="2">2</option>
                                <option value="4">4</option>
                            </select>
                        </div>
                        <ContentSwitcher size={contentSwitchSize} onChange={callBack} options={contentSwitchOptions}/>
                    </div>
                    <div style={{'marginTop': '20px'} }>
                        <h3>Date Picker</h3>
                        <DatePicker  
                            onDayClick={(day) => {
                                console.log("onDayClick clicked", day);
                                setSelectedDay(day);
                            }}
                            onMonthChange={(dt) => {
                                console.log("onMonthChange clicked", dt);
                            }}
                            maxDate={new Date(2023, 1, 1)}
                            minDate={new Date()}
                            selectedDays={selectedDay}
                        />
                    </div>
                   
                </div>
            </div>
        </Grid>)
}

export default SchedulingComponents;